export default "__VITE_ASSET__Dh0aH$QQ__"